import { render } from "./EventVendorManagementSystem.vue?vue&type=template&id=22461cd4"
import script from "./EventVendorManagementSystem.vue?vue&type=script&lang=js"
export * from "./EventVendorManagementSystem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__